@if (show) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content small" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="faPen"></fa-icon>
          <span>{{ 'BENCHMARK.RENAME_TITLE' | translate }}</span>
        </h3>
        <button class="close-btn" (click)="onClose()" [disabled]="loading" type="button">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>

      <div class="modal-body">
        <p>{{ 'BENCHMARK.RENAME_MESSAGE' | translate:{ name: itemName } }}</p>

        <div class="form-group">
          <label for="benchmarkRenameInput">{{ 'BENCHMARK.RENAME_LABEL' | translate }}</label>
          <input
            id="benchmarkRenameInput"
            type="text"
            class="form-control"
            maxlength="255"
            [placeholder]="'BENCHMARK.RENAME_PLACEHOLDER' | translate"
            [(ngModel)]="value"
            [disabled]="loading"
            (keydown.enter)="onConfirm()"
          />
        </div>

        <div class="form-actions">
          <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" [disabled]="loading" (clicked)="onClose()">
          </app-button>
          <app-button [text]="'BUTTON.RENAME' | translate" [icon]="faPen" [loading]="loading" [disabled]="!value.trim()" (clicked)="onConfirm()">
          </app-button>
        </div>
      </div>
    </div>
  </div>
}
